/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_NaInputs */



/**
* | output |
* | --- |
* | "N/A" |
*
* @param {Common_NaInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_na = /** @type {((inputs?: Common_NaInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_NaInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("N/A")
	if (locale === "es") return /** @type {LocalizedString} */ ("N/A")
	if (locale === "pt") return /** @type {LocalizedString} */ ("N/D")
	if (locale === "it") return /** @type {LocalizedString} */ ("N/D")
	return /** @type {LocalizedString} */ ("N/A")
});